<template>
  <block-item-card
    :min-height="minBlockHeight"
    class="gradient-grey-06-bg"
    style="padding: 20px !important;"
  >
    <v-row class="header-row">
      <img
        src="/img/dashboard/interest_rate_risk_set_icon.svg"
        alt="Interest Rate Risk Icon"
        class="svg-icon"
      >

      <span
        class="header-row-text"
      >{{ $t('Dashboard.Banking.InterestRateRisk.Title') }}</span>
    </v-row>

    <!-- Top Row: Asset & Liability Management and Repricing Speed -->
    <v-row
      class="components-row mb-0"
      style="max-height: 290px;"
    >
      <v-col
        class="px-0"
        cols="8"
        style="padding-bottom: 0"
      >
        <asset-and-liability-management />
      </v-col>
      <v-col
        cols="4"
        style="padding-bottom: 0"
      >
        <repricing-speed />
      </v-col>
    </v-row>

    <!-- Middle Row: Risk Distribution -->
    <v-row
      class="components-row"
      style="margin-top: 0; margin-bottom: 0"
    >
      <v-col
        cols="12"
        style="padding-bottom: 0"
      >
        <risk-distribution />
      </v-col>
    </v-row>

    <!-- Bottom Row: Regulatory Thresholds -->
    <v-row
      class="components-row"
      style="margin-top: 0; margin-bottom: 0"
    >
      <v-col
        class="px-0"
        cols="12"
        style="padding-bottom: 0"
      >
        <regulatory-thresholds />
      </v-col>
    </v-row>
  </block-item-card>
</template>

<script>

import routerTabState        from '@/mixins/routerTabState'
import BlockItemCard from '@/theme/default/components/common/BlockItemCard.vue'
import AssetAndLiabilityManagement from './interest-rate-risk/AssetAndLiabilityManagement.vue'
import RepricingSpeed from './interest-rate-risk/RepricingSpeed.vue'
import RiskDistribution from './interest-rate-risk/RiskDistribution.vue'
import RegulatoryThresholds from './interest-rate-risk/RegulatoryThresholds.vue'

export default {
  name      : 'InterestRateRisk',
  components: {
    BlockItemCard,
    AssetAndLiabilityManagement,
    RepricingSpeed,
    RiskDistribution,
    RegulatoryThresholds
  },
  directives: {},
  mixins    : [routerTabState],
  dataStore : {
    niiAnalysisData: 'NII.FindNIIAnalysis'
  },
  enums    : {},
  dataModel: null,
  data () {
    return {
      minBlockHeight: 700
    }
  },
  computed: {
  },
  methods: {}
}
</script>

<style scoped>
.header-row {
  font-family: Inter, Aeonik, Roboto, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  color: #607D8B;
  padding-left: 13px;
  padding-top: 10px;
  display: flex;
  align-items: center;
}

.header-row-text {
  padding-left: 4px;
  color: #607D8B;
}

.svg-icon {

  display: block;
}

.components-row {
  margin-bottom: 20px;
}

.components-row:last-child {
  margin-bottom: 0;
}
</style>
